import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled, { createGlobalStyle } from 'styled-components';
export const EditorStyles = createGlobalStyle `
  .ck-editor__editable {
    color: ${themeGet('colors.text.300')};
    font-size: ${themeGet('fontSize.medium')};
    font-family: ${themeGet('fontFamily.default')};

    border: none !important;
    box-shadow: none !important;

    > p,
    > p.ck-placeholder::before {
      line-height: 160%;
    }
  }

  .ck.ck-balloon-panel {
    background: transparent;
  }

  .ck.ck-list.ck-mentions {
    --ck-line-height-base: ${themeGet('lineHeight.neutralized')};
    --ck-font-face: ${themeGet('fontFamily.default')};
    --ck-border-radius: ${themeGet('borderRadius.md')};

    gap: ${themeGet('spacing.xs')};
    padding: ${themeGet('spacing.sm')};
    border: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
    border-radius: ${themeGet('borderRadius.md')};
    box-shadow: ${themeGet('dropShadow.300')};
  }

  .custom-mention-pill {
    color: ${themeGet('colors.text.300')};
    font-size: ${themeGet('fontSize.medium')};
    font-weight: ${themeGet('fontWeight.semibold')};

    padding: ${themeGet('spacing.xs')} ${themeGet('spacing.sm')};

    border-radius: ${themeGet('borderRadius.sm')};
    background-color: ${themeGet('colors.background.75')};
    border: solid ${pxToRem(1)} ${themeGet('colors.background.100')};

    &::before {
      content: '@';
      position: relative;
      top: ${pxToRem(-1)};
    }
  }

  .custom-mention-item {
    display: flex;
    flex-direction: column;
    cursor: pointer !important;
    border-radius: ${themeGet('borderRadius.sm')} !important;
    padding: ${themeGet('spacing.md')} ${themeGet('spacing.lg')} !important;

    &__name {
      cursor: pointer !important;
      --ck-font-size-base: ${themeGet('fontSize.small')};
      --ck-color-text: ${themeGet('colors.text.300')};
      font-size: ${themeGet('fontSize.medium')};
    }

    &__type {
      cursor: pointer !important;
      --ck-font-size-base: ${themeGet('fontSize.tiny')};
      --ck-color-text: ${themeGet('colors.text.100')};
      font-size: ${themeGet('fontSize.small')};
    }

    &.ck-button {
      transition: background-color 125ms ease-in-out;
    }

    &.ck-on {
      --ck-color-list-button-on-background: ${themeGet('colors.background.100')};
      --ck-color-list-button-on-background-focus: ${themeGet('colors.gray.100')};
    }
  }
`;
export const EditorContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.md')};
  padding: ${themeGet('spacing.md')};
  border-radius: ${themeGet('borderRadius.md')};
  border: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
  background-color: ${themeGet('colors.background.50')};
  min-height: ${pxToRem(182)}; // this is 4 rows of text before the editor height grows in height
`;
export const ToolbarContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${themeGet('spacing.sm')};
  padding: ${themeGet('spacing.sm')};
  border-radius: ${themeGet('borderRadius.md')};
  background-color: ${themeGet('colors.background.100')};
`;
export const ToolbarDivider = styled.div `
  width: ${pxToRem(1)};
  height: ${pxToRem(16)};
  background-color: ${themeGet('colors.gray.100')};
  margin: 0 ${themeGet('spacing.md')};
`;
